'use client';
import React, { FC } from 'react';
import { DynamicComponent } from '@/components';
import useFeatureContent from '@/hooks/useFeatureContent';
import { TypeLaunchDarklyVariationContainerFields } from '@/core/generated-types';

export const VariationContainer: FC<
  TypeLaunchDarklyVariationContainerFields
> = (props) => {
  const content = useFeatureContent({ ...props });

  return <DynamicComponent component={content} />;
};
